export const isCompleted = (action) => {
  return action.completed === true
}
